/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren, Fragment } from 'preact';
import { ItemContext } from '../UNSAFE_Collection';

/**
 * Props for the Collection Component
 */
export type Props<T> = {
  /**
   * An array of items
   */
  items: T[];
  /**
   * A function to render each item
   */
  children: (context: ItemContext<T>) => ComponentChildren;
};

/**
 * Component that renders an array of data.
 */
export function Collection<T>({ items, children }: Props<T>) {
  return (
    <Fragment>
      {items.map((data: T, index: number) => {
        const ctx = { index, data };
        return children(ctx);
      })}
    </Fragment>
  );
}
